import {
  IconTabCasino,
  IconTabHelp,
  IconTabHome,
  IconTabMenu,
  IconTabMyBets,
  IconTabPromos,
  IconTabSport,
} from '../components/mobile/MobileIcons';

export const MOBILE_BOTTOM_NAV_ICONS = {
  home: IconTabHome,
  casino: IconTabCasino,
  sport: IconTabSport,
  my_bets: IconTabMyBets,
  promos: IconTabPromos,
  help: IconTabHelp,
  menu: IconTabMenu,
};

export function resolveMobileBottomNavItems(navItems) {
  if (!navItems?.length) return [];

  return navItems
    .map((item) => {
      const pageId = item.pageId || item.page_id || item.id;
      if (!pageId || !item.label) return null;
      return {
        id: item.id ?? pageId,
        pageId,
        label: item.label,
        href: item.href || null,
        icon: MOBILE_BOTTOM_NAV_ICONS[pageId] || IconTabMenu,
      };
    })
    .filter(Boolean);
}

export function isMobileBottomNavActive(pageId, {
  activePage,
  accountSection,
  menuOpen,
  accountSheetOpen,
  accountSheetSection,
  sportFilter,
}) {
  if (pageId === 'menu') return menuOpen;
  if (pageId === 'my_bets') {
    if (accountSheetOpen && accountSheetSection === 'bets') return true;
    return activePage === 'account' && accountSection === 'bets';
  }
  if (pageId === 'home') return activePage === 'home';
  if (pageId === 'casino') return activePage === 'casino';
  if (pageId === 'sport') return activePage === 'sport';
  if (pageId === 'promos') return activePage === 'promos';
  if (pageId === 'help') return activePage === 'help';
  return activePage === pageId;
}

export function navigateMobileBottomItem(pageId, item, { onNavigate, onOpenMenu, onOpenAccount }) {
  if (item?.href) {
    window.location.assign(item.href);
    return;
  }
  switch (pageId) {
    case 'home':
      onNavigate('home');
      break;
    case 'casino':
      onNavigate('casino', { casinoTabId: '-1' });
      break;
    case 'sport':
      onNavigate('sport', { sportFilter: 'all' });
      break;
    case 'promos':
      onNavigate('promos');
      break;
    case 'help':
      onNavigate('help');
      break;
    case 'my_bets':
      // Cross-origin Nexus iframe cannot be controlled without a proxy.
      // Open site account bets (includes sportsbook history).
      if (onOpenAccount) onOpenAccount('bets');
      else onNavigate('account', { accountSection: 'bets' });
      break;
    case 'menu':
      onOpenMenu?.();
      break;
    default:
      break;
  }
}
